import React from 'react';

const TimelineSection2: React.FC = () => {
  return (
    <section className="bg-[#F6F6F6] py-16 px-4">
      <div className="mx-auto px-4 md:px-10 lg:px-32 w-full">
        {/* Main Title */}
        <div className="max-w-[970px] mx-auto">
          <h1 className="font-bold text-center w-full lg:text-[40px] md:text-[32px] text-[28px] leading-[100%] text-[#192842] tracking-[1%] lg:mb-20 mb-10">
          Why The Wealthy Miner Is Unique
        </h1>
        </div>
        
        {/* Timeline Container */}
        <div className="max-w-[970px] mx-auto relative">
          {/* Timeline Line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 w-[0.5px] h-full bg-black"></div>
          
          {/* Timeline Items */}
          <div className="space-y-6 md:space-y-10">
            {/* Item 1 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8 text-right">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                  Rob isn’t just a mining analyst…
                  </p>
                </div>
              </div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8"></div>
            </div>
            
            {/* Item 2 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8"></div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                  He is an active mining company executive who grew a $5 million market cap company into a <span className="font-bold text-[#192842] md:text-[35px] text-[20px]">$1 billion one.</span>.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Item 3 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8 text-right">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                  Rob managed real money—and real companies—in the mining sector.                  </p>
                </div>
              </div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8"></div>
            </div>
            
            {/* Item 4 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8"></div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                  Unlike most “analysts,” he has hands-on experience and a stellar track record to prove that his method works.                  </p>
                </div>
              </div>
            </div>
            
            {/* Item 5 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8 text-right">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                  Now Rob is about to build the biggest project of his life yet… <span className="font-bold text-[#192842] md:text-[35px] text-[20px]">The Wealthy Miner.</span>.
                  </p>
                </div>
              </div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8"></div>
            </div>
            
            {/* Item 6 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8"></div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                  His mission is to help investors like YOU to build better mining portfolios… and potentially to see life-changing returns.                  </p>
                </div>
              </div>
            </div>
            
            {/* Item 7 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8 text-right">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                  Rob’s objective and technical approach has earned him a fantastic reputation in
                  Toronto, Vancouver, and other junior mining capitals.                  </p>
                </div>
              </div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8"></div>
            </div>
            
            {/* Item 8 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8"></div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                  His wealth of experience could turn into your real wealth.                  </p>
                </div>
              </div>
            </div>
            
            {/* Item 9 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8 text-right">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                  Join his elite club now to profit from his knowledge and know-how.                  </p>
                </div>
              </div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8"></div>
            </div>
            </div>
        </div>
        
        {/* Call-to-Action Button */}
        <div className="text-center flex flex-col items-center justify-center mt-12">
        <img src="/images/Logo.webp" alt="Timeline" className="w-[600px] h-auto mb-10" />
          <a href="https://the-wealthy-miner.mn.co/" target="_blank" rel="noopener noreferrer" className="inline-block w-full lg:w-auto">
            <button className="bg-[#0B6054] text-white font-bold py-4 lg:px-44 rounded-lg w-full lg:w-auto lg:text-lg uppercase tracking-wide transition-colors duration-300 shadow-lg hover:shadow-xl">
              JOIN THE WEALTHY MINER NOW
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default TimelineSection2;
